var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16.2188L21.8438 12.0938C21.7031 11.9531 21.5625 11.9531 21.4219 12.0938L20.8125 12.75C20.6719 12.8906 20.7188 13.0781 20.8125 13.1719L23.5781 15.7969H18.1875L16.6875 18.7969H10.2656L8.76562 15.7969H3.375L6.14062 13.1719C6.28125 13.0781 6.28125 12.8906 6.1875 12.75L5.53125 12.0938C5.4375 11.9531 5.25 11.9531 5.10938 12.0938L0.703125 16.2188C0.234375 16.6406 0 17.25 0 17.8594V22.5C0 23.7656 0.984375 24.75 2.25 24.75H24.75C25.9688 24.75 27 23.7656 27 22.5V17.8594C27 17.25 26.7188 16.6406 26.25 16.2188ZM25.5 22.5C25.5 22.9219 25.125 23.25 24.75 23.25H2.25C1.82812 23.25 1.5 22.9219 1.5 22.5V18C1.5 17.625 1.82812 17.25 2.25 17.25H7.875L9.375 20.25H17.625L19.125 17.25H24.75C25.125 17.25 25.5 17.625 25.5 18V22.5ZM19.5 6.75H16.5V1.875C16.5 1.26562 15.9844 0.75 15.375 0.75H11.625C10.9688 0.75 10.5 1.26562 10.5 1.875V6.75H7.5C6.14062 6.75 5.48438 8.39062 6.42188 9.32812L12.4219 15.3281C12.9844 15.9375 13.9688 15.9375 14.5312 15.3281L20.5312 9.32812C21.4688 8.39062 20.8125 6.75 19.5 6.75ZM13.5 14.25L7.5 8.25H12V2.25H15V8.25H19.5L13.5 14.25Z",
    fill: "#2D5049",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIn);
export default __webpack_public_path__ + "static/media/inbox-in.f4779d0c0b3de50c5b483ad7dd0bdafe.svg";
export { ForwardRef as ReactComponent };